// extracted by mini-css-extract-plugin
export default {"Financial":"Financial_Financial__XuS2U","heading":"Financial_heading__1pMJn","tab":"Financial_tab__uTLpF"};